'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp; // import Autosuggest from 'react-autosuggest'

// import { chain } from 'lodash'
// import moment from 'moment'

// import Helmet from 'react-helmet'

// import convert from '../../helpers/convert'
// import analytics from '../../helpers/analytics'
// import {Row, Col} from 'react-flexbox-grid'
// import {Link} from '../../components'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _reduxAsyncConnect = require('redux-async-connect');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./FundRedirect.css');

var FundRedirect = (_dec = (0, _reactRedux.connect)(function (state) {
  return { result: state.shareClass.result,
    loading: state.shareClass.loading, loaded: state.shareClass.loaded, error: state.shareClass.error };
}, searchActions), _dec2 = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true, // need otherwise cient navigate is blocked until the page is loaded
  promise: function promise(_ref) {
    var params = _ref.params,
        _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId));
  }
}]), _dec3 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FundRedirect, _Component);

  function FundRedirect(props) {
    (0, _classCallCheck3.default)(this, FundRedirect);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FundRedirect.__proto__ || (0, _getPrototypeOf2.default)(FundRedirect)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(FundRedirect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._mounted = true;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._mounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.result) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, { options: { scale: 0.70, top: '2.0rem' }, loaded: false })
        );
      } else if (this.props.result && this.props.result.fund && this.props.result.shareClass) {
        var shareClass = this.props.result.shareClass;
        var fund = this.props.result.fund;
        var ticker = shareClass.ticker ? shareClass.ticker : 'N';
        var name = _format2.default.sanitize(fund.name);
        var urlStart = _config2.default.routes.fund + '/' + name + '/' + ticker;
        var urlEnd = shareClass.fund_id + '/' + shareClass.investment_vehicle_id;
        var trueUrl = urlStart + '/profile/' + urlEnd;
        this.context.router.push(trueUrl);
        // shouldn't reach here
        var url = _config2.default.domain + _config2.default.routes.fund + '/' + shareClass.fund_id + '/' + shareClass.investment_vehicle_id;
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _container2.default.helmet(shareClass.fund_legal_name, 'Deforestation Free Funds results for ' + shareClass.fund_legal_name, url)
        );
      } else {
        this.context.router.push(_config2.default.routes.notFound);
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, { options: { scale: 0.70, top: '2.0rem' }, loaded: false })
        );
      }
    }
  }]);
  return FundRedirect;
}(_react.Component), _class2.propTypes = {
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.object
}, _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class) || _class) || _class);
exports.default = FundRedirect;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FundRedirect/FundRedirect.js
// module id = 1334
// module chunks = 0